import { useContext, useEffect } from 'react';

import { AuthContext } from '@/js/libs/use-auth';

import useAppLogout from './useAppLogout';
import useLocalStorage, { StorageKey } from './useLocalStorage';

// We need to do a forced logout to enable 2FA (production only).
// This hook should be deleted after December 1, 2023.
const useOneTimeLogout = ({ disabled = true }: { disabled?: boolean } = {}) => {
  const { loadBoolean, saveBoolean } = useLocalStorage();
  const logout = useAppLogout();
  const {
    identity: { user },
  } = useContext(AuthContext);

  const forcedLogoutCompleted = loadBoolean(StorageKey.FORCED_LOGOUT_COMPLETED);

  useEffect(() => {
    if (forcedLogoutCompleted || disabled) {
      return;
    }

    if (user) {
      logout();
    }
    saveBoolean(StorageKey.FORCED_LOGOUT_COMPLETED, true);
  }, [disabled, forcedLogoutCompleted, logout, saveBoolean, user]);
};

export default useOneTimeLogout;
